export enum AnalyticsMetricas {
    Quantidade = "Quantidade",
    Acessos = "Acessos"
}